<ng-container [formGroup]="form">
    <mat-radio-group
        [formControlName]="question.key"
        appearance="outline"
        class="ca-radio-group"
        [id]="question.key"
        [attr.data-testid]="question.key"
        [ngClass]="question.styles"
    >
        @for (option of question.options; track trackByKey($index, option)) {
            <mat-radio-button
                [disableRipple]="true"
                [id]="question.key + (option.id || option.value)"
                [attr.data-testid]="question.key + (option.id || option.value)"
                [disabled]="option.disabled"
                [checked]="option.checked"
                [value]="option.value"
                class="inline-block"
                [ngClass]="{
                    'ca-radio-with-image': option.img && !(option.icon || option.iconGroup),
                    'ca-radio-with-icon': (option.icon || option.iconGroup) && !option.img,
                    'ca-radio-disabled': option.disabled || question.disabled
                }"
            >
                @if (!option.img && !option.iconGroup && option.icon) {
                    <ca-icon [icon]="option.icon" class="ca-icon-s-24-p-0-f-24"></ca-icon>
                }
                @if (!option.img && !option.icon && option.iconGroup) {
                    <div class="ca-radio-icon-group">
                        @for (icon of option.iconGroup; track icon) {
                            <ca-icon [icon]="icon" class="ca-icon-s-24-p-0-f-24"></ca-icon>
                        }
                    </div>
                }
                @if (!option.icon && option.img) {
                    <img [src]="option.img" [alt]="option.key" class="mb-2" />
                }
                <span class="ca-truncate-text">{{ option.key | translate }}</span>
                @if (option.subtext && !option.img) {
                    <span class="block radio-subtext">{{ option.subtext | translate }}</span>
                }
            </mat-radio-button>
        }
    </mat-radio-group>
    @if (question.validators.length) {
        <div class="ca-subscript relative mt-2">
            @if (isInvalid && errorMessage) {
                <div class="absolute ca-error-message" @slideDown>
                    <ca-form-error-message [attr.data-testid]="question.key + '-error-message'">
                        {{ errorMessage | translate }}
                    </ca-form-error-message>
                </div>
            }
        </div>
    }
</ng-container>
